import React, { useEffect, createContext, useState, useContext } from 'react'

export const CompareBasketContext = createContext(
  /** @type {import("./compareBasketProvider").CompareBasketContext} */ ({
    items: [],
    setItems: items => items,
    limit: 4,
    enabled: false,
  })
)

/** @type {import("./compareBasketProvider").default} */
export const CompareBasketProvider = ({ children, basket = [], limit = 4, enabled = true, onChange }) => {
  const [items, setItems] = useState(basket)

  useEffect(() => {
    if (onChange) {
      onChange(items)
    }
  }, [onChange, items])
  return (
    <CompareBasketContext.Provider value={{ items, setItems, limit, enabled }}>
      {children}
    </CompareBasketContext.Provider>
  )
}

/** @returns {import("./compareBasketProvider").UseCompareBasket} */
export const useCompareBasket = () => {
  const { setItems, items, limit, enabled } = useContext(CompareBasketContext)
  const isFull = items.length >= limit

  const isInBasket = item => items.find(i => i.id === item.id) !== undefined
  const addItem = item => {
    if (isFull || isInBasket(item)) {
      return
    }
    setItems(stateItems =>
      stateItems.concat([
        {
          id: item.id,
          slug: item.slug,
          name: item.name,
          logo_url: item.logo_url,
          cta_urls: { detail: item.cta_urls?.detail },
        },
      ])
    )
  }

  return {
    items,
    isFull,
    isEnabled: enabled,
    addItem,
    isInBasket,
    toggleItem: item => {
      const filtered = items.filter(i => i.id !== item.id)
      if (filtered.length === items.length) {
        addItem(item)
        return
      }
      setItems(filtered)
    },
    clear: () => setItems([]),
    removeItem: item => setItems(stateItems => stateItems.filter(i => i.id !== item.id)),
    getUrl: listings => {
      const listingsToUse = listings || items

      if (listingsToUse.length < 2) {
        return null
      }
      const [primary, ...others] = listingsToUse.concat([]).sort((a, b) => a.id - b.id)
      return `${primary.cta_urls?.detail}compare/${others.map(({ slug }) => slug).join('-vs-')}/`
    },
  }
}
